/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Response_TitleInputs */

const en_contact_response_title = /** @type {(inputs: Contact_Response_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Response time`)
};

const ko_contact_response_title = /** @type {(inputs: Contact_Response_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`응답 시간`)
};

const ja_contact_response_title = /** @type {(inputs: Contact_Response_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返信までの時間`)
};

/**
* | output |
* | --- |
* | "Response time" |
*
* @param {Contact_Response_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_response_title = /** @type {((inputs?: Contact_Response_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Response_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_response_title(inputs)
	if (locale === "ko") return ko_contact_response_title(inputs)
	return ja_contact_response_title(inputs)
});